var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabsLayout',[_c('ElTabPane',{attrs:{"name":"complex","label":"效果报表"}}),_c('ElTabPane',{attrs:{"name":"realtime","label":"实时数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }